import { createEpicFromAsyncAction, createEpicFromAsyncActionEmptyRequest } from '../../../utils';
import { createContact, deleteContact, fetchContacts } from './contactsSlices';

const fetchContacts$ = createEpicFromAsyncActionEmptyRequest(fetchContacts, ({ contactClient }) =>
    contactClient.getAll()
);

const createContact$ = createEpicFromAsyncAction(createContact, (request, { contactClient }) =>
    contactClient.create(request).then(contactId => {
        return { ...request, contactId: contactId };
    })
);

const deleteContact$ = createEpicFromAsyncAction(deleteContact, (request, { contactClient }) =>
    contactClient.delete(request).then(() => request)
);

export default [fetchContacts$, createContact$, deleteContact$];
